export default {
  data() {
    return {
      gift_code: 'abcdef12345',
      isInputted: true
    }
  },
  methods: {
    onFocus() {
      this.isInputted = true
    },
    onBlur() {
      this.isInputted = this.gift_code.length !== 0
    }
  }
}
